import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import toast from "react-hot-toast"
import { EDIT_ABONNEMENT, LIST_FORFAIT } from '../../Utils/constant'
import doc from '../../assets/images/demande.png'
import { updateOne } from "../../services/service"
import { useStoreBatiment } from '../../store/Paramettre/batimentStore'
import { useStoreEquipement } from '../../store/Paramettre/equipementStore'
import { useIntentionStore } from "../../store/intentionStore"
import { useStoreApp } from '../../store/storeApp'
import { SubmitButton } from "../Widget/SubmitButton"

export const UpdateDemandeIntention = ({ item }) => {
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [error, setError] = useState(null);
    const [loadingLocalisation, setLoadingLocalisation] = useState(false);
    const handleClick = () => {
        setLoadingLocalisation(true);
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLoadingLocalisation(false);
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                    setError(null);
                },
                (error) => {
                    setLoadingLocalisation(false);
                    setError(error.message);
                },
                {
                    timeout: 10000, // Timeout after 10 seconds
                    maximumAge: 0, // No cache
                    enableHighAccuracy: true, // Request high accuracy
                }
            );
        } else {
            setLoadingLocalisation(false);
            setError(
                "La géolocalisation n'est pas prise en charge par ce navigateur."
            );
            console.error("Geolocation not supported by this browser.");
        }
    };
    const {
        register, unregister,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()
    const [isSubmit, setIsSubmit] = useState(false);

    const forfaits = useStoreApp()
    const batiments = useStoreBatiment()
    const typeEquipements = useStoreEquipement()

    useEffect(() => {
        if (item) {
            reset();
        }
    }, [item, reset]);

    useEffect(() => {
        forfaits.getData(LIST_FORFAIT, { page: 0, param: "", size: 10 }, '')
        typeEquipements.equipement({ page: 0, param: "", size: 10 })
        batiments.batiments({ page: 0, param: "", size: 10 })

        if (item.statusConfirmation === 'CONFIRMER') {
            unregister("equipementId")
            unregister("forfaitId")
            unregister("batimentId")
            unregister("statusConfirmation")
        }
    }, [item])
    const intentions = useIntentionStore()

    const submit = (data) => {
        setIsSubmit(true)
        updateOne(EDIT_ABONNEMENT, item.id, { ...data, latitude: latitude, longitude: longitude }).then((res) => {
            if (res.status === 200) {
                setIsSubmit(null)
                reset()
                intentions.intentionList({ page: 0, param: ``, size: 8 }, `&statusConfirmation=&status=&date=&isActive=true`)
                toast.success('Intention modifié')
                console.log(res);
                localStorage.setItem('numeroTicket', res?.data?.eligibilite?.numeroTicket)
            }
        }).catch((err) => {
            setIsSubmit(false)
            toast.error(err?.response?.data?.donnee)
        })
    }

    return (
        <>
            {
                isSubmit === null ? (
                    <div className='flex justify-center my-28 w-full'>
                        <div className='text-center'>
                            <img className='mx-auto' src={doc} height={80} width={80} alt="" />
                            <p className='font-light mt-2  text-sm'>Intention d'abonnement modifiée</p>
                        </div>
                    </div>
                ) :
                    <form onSubmit={handleSubmit(submit)} className="w-full  mx-auto mt-6">
                        <div className="my-3">
                            <h2 className=" font-medium">Client</h2>
                            <hr />
                        </div>

                        <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                            <label className="form-control grid lg:grid-cols-2 md:grid-cols-2 xl:grid-cols-2 grid-cols-1 gap-2  w-full">
                                <input
                                    {...register('nomPrenoms')}
                                    defaultValue={item?.client?.nomPrenoms}
                                    type="text"
                                    placeholder="Nom & prénoms "
                                    className="input input-bordered w-full h-10 text-sm "
                                />

                                <input
                                    {...register('email')}
                                    type="text"
                                    defaultValue={item?.client?.email}
                                    placeholder="Email"
                                    className="input input-bordered w-full h-10 text-sm "
                                />

                                <input
                                    {...register('contatct')}
                                    type="text"
                                    defaultValue={item?.client?.numero}
                                    placeholder="Contact client"
                                    className="input input-bordered w-full h-10 text-sm "
                                />

                                <input
                                    {...register('secondContact')}
                                    type="text"
                                    defaultValue={item?.client?.secondNumero}
                                    placeholder="Second contact client"
                                    className="input input-bordered w-full h-10 text-sm "
                                />

                                <input
                                    type="text"
                                    defaultValue={item?.numeroMtn}
                                    {...register('numeroAvantage')}
                                    placeholder="Numero pour les avantages"
                                    className="input input-bordered w-full h-10 text-sm "
                                />

                                <select {...register('typeClient')} className="select select-bordered w-full h-10">
                                    <option disabled selected>
                                        type de client
                                    </option>
                                    <option value='PARTICULIER'>Particulier</option>
                                    <option value='ENTREPRISE'>Entreprise</option>
                                </select>

                                {
                                    item?.statusConfirmation === 'CONFIRMER' ? null : (
                                        <>
                                            <select {...register('equipementId')} className="select select-bordered w-full h-10">
                                                <option disabled selected>
                                                    type d'équipement
                                                </option>
                                                {
                                                    typeEquipements?.data?.equipements?.map((item) => (
                                                        <option value={item.id}>{item.designation}</option>
                                                    ))
                                                }
                                            </select>

                                            <select {...register('forfaitId')} className="select select-bordered w-full h-10">
                                                <option disabled selected>
                                                    Choisir un forfait
                                                </option>
                                                {
                                                    forfaits?.data?.data?.map((item) => (
                                                        <option value={item.id}>
                                                            {item.designation}
                                                        </option>
                                                    ))
                                                }

                                            </select>

                                            <select {...register('batimentId')} className="select select-bordered w-full h-10">
                                                <option disabled selected>
                                                    type de batiment
                                                </option>
                                                {
                                                    batiments?.data?.batiments?.map((item) => (
                                                        <option value={item.id}>{item.designation}</option>
                                                    ))
                                                }
                                            </select>
                                        </>
                                    )
                                }

                            </label>
                        </div>

                        <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                            <label className="form-control grid lg:grid-cols-2 md:grid-cols-2 xl:grid-cols-2 grid-cols-1 gap-2  w-full">
                                <input
                                    {...register('commune')}
                                    defaultValue={item?.commune}
                                    type="text"
                                    placeholder="ville ou commune du client"
                                    className="input input-bordered w-full h-10 text-sm mt-1 "
                                />

                                <input
                                    {...register('quartier')}
                                    defaultValue={item?.quartier}
                                    type="text"
                                    placeholder="quartier du client"
                                    className="input input-bordered w-full h-10 text-sm "
                                />
                            </label>
                        </div>

                        {
                            item?.statusConfirmation === 'CONFIRMER' ? null :
                                <select
                                    {...register('statusConfirmation')}
                                    className="mt-3 select select-bordered w-full h-10 max-w-sm"
                                >
                                    <option disabled selected>
                                        Confirmez-vous ?
                                    </option>
                                    <option value="CONFIRMER">Oui</option>
                                    <option value="NON_CONFIRMER">Non</option>
                                </select>
                        }



                        {
                            isSubmit === null ? null : (
                                <SubmitButton isSubmit={isSubmit} label={"Modifier l'intention"} />
                            )
                        }

                    </form>
            }
        </>
    )
}
